import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import {
    DetailedHTMLProps,
    HTMLAttributes,
    RefObject,
    useEffect,
    useState,
} from "react";
import { spaceBetween } from "../../../common/util/Array/spaceBetween";
import { zIndex } from "../../zApps/Layout/zIndex";
import { CountryCode, countryNames } from "./countryCodeAndName";
import "/node_modules/flag-icons/css/flag-icons.min.css";

type Props = DetailedHTMLProps<
    HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
> & {
    code: CountryCode;
    containerRef?: RefObject<HTMLDivElement>; // パネル上など、windowのスクロールの影響を受けない箇所にある場合、popoverの出現位置のズレを防ぐため指定
};

const strangeShapedFlag: CountryCode[] = ["np"];

export function CountryFlag({ code, className, containerRef, ...rest }: Props) {
    const c = useStyles();

    const [container, setContainer] = useState<HTMLDivElement | undefined>(
        undefined
    );
    useEffect(() => {
        setContainer(containerRef?.current ?? undefined);
    }, [containerRef]);

    if (!code) {
        return null;
    }
    return (
        <Tooltip
            title={<span className="medium">{countryNames[code]}</span>}
            classes={{
                popper: c.tooltipPopper,
            }}
            PopperProps={{ container }}
        >
            <span
                {...rest}
                className={spaceBetween(
                    code && `fi fi-${code}`,
                    !strangeShapedFlag.includes(code) && c.flagWithOutline,
                    className
                )}
            />
        </Tooltip>
    );
}
const useStyles = makeStyles(theme => {
    return {
        flagWithOutline: {
            border: `solid 1px ${theme.palette.grey[300]}`,
            backgroundSize: "cover !important",
            backgroundPosition: "center",
            boxSizing: "content-box",
        },
        tooltipPopper: {
            zIndex: zIndex.maxValue,
        },
    };
});

